export enum TelematicsProviderIdentifier {
  SixfoldCarrierTelematicsApi = 'sixfold_carrier_telematics_api',
  Ttc = 'ttc',
}
